import { Breadcrumbs as d } from "@mui/material";
import t from "./ChevronRightRounded.mjs";
import { styled as o } from "./styled2.mjs";
const s = o(d)`
	&.MuiBreadcrumbs-root {
		border-radius: 8px;
		border: ${({ $outline: r, theme: e }) => r ? `1px solid ${e.palette.other.divider}` : "none"};
		padding: ${({ $outline: r }) => r ? "8px" : "0"};
	}

	.MuiBreadcrumbs-separator {
		margin: 0 4px;
	}
`, i = o(t)`
	color: ${({ theme: r }) => r.palette.grey[300]};
`;
export {
  s as Breadcrumbs,
  i as ChevronIcon
};
//# sourceMappingURL=styles57.mjs.map
